module.exports = __webpack_public_path__ + "static/media/phonePreview.e668ff5f.svg";